var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.416H11.5M4.83333 12.4993H13.1667M3.16667 1.66602H14.8333C15.7538 1.66602 16.5 2.49512 16.5 3.51787V16.4808C16.5 17.5036 15.7538 18.3327 14.8333 18.3327H3.16667C2.24619 18.3327 1.5 17.5036 1.5 16.4808V3.51787C1.5 2.49512 2.24619 1.66602 3.16667 1.66602ZM8.998 5.17596C8.41486 4.52668 7.44243 4.35203 6.71179 4.94657C5.98115 5.54112 5.87828 6.53518 6.45206 7.23835C7.02583 7.94152 8.998 9.58268 8.998 9.58268C8.998 9.58268 10.9702 7.94152 11.5439 7.23835C12.1177 6.53518 12.0274 5.53487 11.2842 4.94657C10.541 4.35828 9.58115 4.52668 8.998 5.17596Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipIcon);
export default __webpack_public_path__ + "static/media/membershipIcon.8c20341850d6226840eaeb37a0470d0b.svg";
export { ForwardRef as ReactComponent };